<template>
  <div class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
    <div class="d-lg-none order-0 my-2">
      <div class="d-flex justify-content-between align-items-center text-center calendar-date-tools">
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Previous Month"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="previousMonthClicked">
          <i class="material-icons">fast_rewind</i>
          <p class="mb-0">MONTH</p>
        </a>
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Previous Week"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="previousWeekClicked">
          <i class="material-icons">skip_previous</i>
          <p class="mb-0">WEEK</p>
        </a>
        <a
          v-if="dateSelectionDisplayDay"
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Previous Day"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="previousDayClicked">
          <i class="material-icons" style="moz-transform: scaleX(-1); o-transform: scaleX(-1); -webkit-transform: scaleX(-1); transform: scaleX(-1); filter: FlipH; -ms-filter: 'FlipH'">play_arrow</i>
          <p class="mb-0">DAY</p>
        </a>
        <a
          v-if="dateSelectionDisplayDay"
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Next Day"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="nextDayClicked">
          <i class="material-icons">play_arrow</i>
          <p class="mb-0">DAY</p>
        </a>
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Next Week"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="nextWeekClicked">
          <i class="material-icons">skip_next</i>
          <p class="mb-0">WEEK</p>
        </a>
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Next Month"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="nextMonthClicked">
          <i class="material-icons">fast_forward</i>
          <p class="mb-0">MONTH</p>
        </a>
      </div>
    </div>

    <div class="d-none d-lg-block my-2">
      <div class="d-flex justify-content-between align-items-center text-center calendar-date-tools">
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Previous Month"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="previousMonthClicked">
          <i class="material-icons">fast_rewind</i>
          <p class="mb-0">MONTH</p>
        </a>
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Previous Week"
          class="calendarWeekGrid_Button_PrevNext mx-4"
          @click.prevent="previousWeekClicked">
          <i class="material-icons">skip_previous</i>
          <p class="mb-0">WEEK</p>
        </a>
        <a
          v-if="dateSelectionDisplayDay"
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Previous Day"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="previousDayClicked">
          <i class="material-icons" style="moz-transform: scaleX(-1); o-transform: scaleX(-1); -webkit-transform: scaleX(-1); transform: scaleX(-1); filter: FlipH; -ms-filter: 'FlipH'">play_arrow</i>
          <p class="mb-0">DAY</p>
        </a>
      </div>
    </div>

    <div class="py-2">
      <date-picker
        ref="datePicker"
        v-if="datePickerVisible"
        :config="datePickerConfig"
        v-model="datePicked"
        @dp-change="datePickerChanged">
      </date-picker>

      <span
        v-if="! datePickerVisible"
        class="calendarWeekGrid_Button_PrevNext calendarGrid_Date_Title heading">
        {{ date | moment('ddd, Do MMM YYYY') }}
      </span>
      <button
        v-if="! datePickerVisible"
        class="btn calendarGrid_Date_Btn"
        @click="selectDate">
        <span class="material-icons">date_range</span>
      </button>
    </div>

    <div class="d-none d-lg-block my-4">
      <div class="d-flex justify-content-between align-items-center text-center calendar-date-tools">
        <a
          v-if="dateSelectionDisplayDay"
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Next Day"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="nextDayClicked">
          <i class="material-icons">play_arrow</i>
          <p class="mb-0">DAY</p>
        </a>
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Next Week"
          class="calendarWeekGrid_Button_PrevNext mx-4"
          @click.prevent="nextWeekClicked">
          <i class="material-icons">skip_next</i>
          <p class="mb-0">WEEK</p>
        </a>
        <a
          href="#"
          rel="nofollow"
          data-toggle="tooltip"
          title="Next Month"
          class="calendarWeekGrid_Button_PrevNext"
          @click.prevent="nextMonthClicked">
          <i class="material-icons">fast_forward</i>
          <p class="mb-0">MONTH</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: Object,
      required: true,
    },
    dateSelectionDisplayDay: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      datePickerConfig: {
        format: 'YYYY-MM-DD',
        minDate: moment().startOf('day'),
        showTodayButton: true,
      },
      datePicked: moment(this.date).format('YYYY-MM-DD'),
      datePickerVisible: false,
    };
  },

  computed: {

  },

  watch: {
    datePicked: {
      handler(newDate, oldDate) {
        this.changeQueryString('dt', newDate.format('YYYY-MM-DD'));
        this.$emit('date-changed-on-header', newDate);
      },
      deep: true,
    },
  },

  methods: {
    selectDate() {
      this.datePickerVisible = true;
      this.$nextTick(() => {
        this.$refs.datePicker.dp.show();
      });
    },

    previousDayClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().subtract(1, 'day');

      if ( newDate.isBefore(moment(), 'day') ) {
        newDate = moment();
      }

      this.datePicked = newDate;
    },
    nextDayClicked() {
      this.datePickerVisible = false;
      this.datePicked = this.date.clone().add(1, 'day');
    },

    datePickerChanged() {
      let datePicked = moment(this.datePicked);

      if (this.date.isSame(datePicked)) {
        return;
      }

      this.datePickerVisible = false;

      this.datePicked = datePicked;
    },


    nextMonthClicked() {
      this.datePickerVisible = false;
      this.datePicked = this.date.clone().add(1, 'month');
    },

    previousMonthClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().subtract(1, 'month');

      if ( newDate.isBefore(moment(), 'day') ) {
        newDate = moment();
      }

      this.datePicked = newDate;
    },

    nextWeekClicked() {
      this.datePickerVisible = false;
      this.datePicked = this.date.clone().add(1, 'week');
    },

    previousWeekClicked() {
      this.datePickerVisible = false;
      let newDate = this.date.clone().subtract(1, 'week');

      if ( newDate.isBefore(moment(), 'day') ) {
        newDate = moment();
      }

      this.datePicked = newDate;
    },

    changeQueryString(param, value) {
      let url = new URL(window.location);
      let params = new URLSearchParams(url.search);
      params.set(param, value);
      history.replaceState({}, '', `${location.pathname}?${params}`);
    },
  },

  mounted() {

  },

  beforeDestroy() {

  },
}
</script>
